import { html, render } from 'lit-html'
import { listenForAuthChanges, currentUser } from '../auth.js'
import type { User } from '../types'
import './signin-link.js'
import './signout-link.js'
import './history.js'
import './pomo-tracker.js'
import styles from './pomo-app.css'

export class PomoApp extends HTMLElement {
  #currentUser: User | null = null
  #unsubscribeAuth: (() => void) | null = null
  shadow: ShadowRoot

  constructor() {
    super()
    this.shadow = this.attachShadow({ mode: 'open' })
  }

  connectedCallback(): void {
    listenForAuthChanges()

    this.#unsubscribeAuth = currentUser.subscribe((user) => {
      this.#currentUser = user
      this.render()
    })

    this.render()
  }

  disconnectedCallback(): void {
    if (this.#unsubscribeAuth) {
      this.#unsubscribeAuth()
    }
  }

  render(): void {
    const template = html`
      <style>
        ${styles}
      </style>
      <div class="wrapper">
        <header>
          <h1>Pomodone!</h1>
          <h5>
            A tiny thing by
            <a href="https://jackf.io">Jack Franklin</a>
          </h5>

          ${this.#currentUser
            ? html`
                <p>
                  Signed in as ${this.#currentUser.displayName} from
                  ${this.#currentUser.provider}. <signout-link></signout-link>.
                </p>
              `
            : html`
                <p>
                  Sign in with <signin-link provider="github"></signin-link> or
                  <signin-link provider="google"></signin-link> to track your
                  pomodoros over time.
                </p>
              `}
        </header>
        <div class="body">
          <pomo-tracker></pomo-tracker>
          <pomodoro-history></pomodoro-history>
        </div>
      </div>
    `
    render(template, this.shadow, { host: this })
  }
}

customElements.define('pomo-app', PomoApp)
